(function () {
    'use strict';

    angular
        .module('assets.mybimiboo.com')
        .controller('UsersCtrl', UsersCtrl);

    function UsersCtrl($scope, $state, $location, $http, AuthenticationService, _env) {

        var permissions = [
            { id: 'manage-users', title: 'Full access (also can manage members and organizations)', selected: false },
            { id: 'manage-equipments', title: 'Manage fixed assets', selected: false },
            { id: 'manage-software', title: 'Manage software', selected: false },
            { id: 'manage-trademarks', title: 'Manage intellectual property', selected: false },
            { id: 'manage-library', title: 'Manage Library', selected: false }
        ];

        function getUsers() {
            $http.get(_env.apiUrl + '/users').then(function (response) {
                $scope.users = _.map(response.data, function (user) {
                    user.permissions = _.map(angular.copy(permissions), function (permission) {
                        permission.selected = user.permissions.indexOf('manage-users') > -1 || user.permissions.indexOf(permission.id) > -1;
                        return permission;
                    });
                    return user;
                });
            });
        }

        getUsers();

        $scope.hasPermission = function(user, permission) {
            if (!user.permissions) return false;

            return _.find(user.permissions, function(p) {
                return p.id == permission && p.selected;
            });
        }

        $scope.editUser = function(user) {
            if (user) {
                $scope.editableUser = angular.copy(user);
            } else {
                $scope.editableUser = {
                    permissions: angular.copy(permissions)
                }
            }
            $('#modal-default').modal('show');
        }

        $scope.saveUser = function () {
            if (!$scope.editableUser) return;

            if (!$scope.editableUser.name) {
                error('Name is required');
                return;
            }

            if (!$scope.editableUser.email) {
                error('Email is required');
                return;
            }

            if (!$scope.editableUser.id && !$scope.editableUser.password) {
                error('Password is required');
                return;
            }

            var data = {
                email: $scope.editableUser.email,
                name: $scope.editableUser.name,
                permissions: _.map(_.filter($scope.editableUser.permissions, function(p) { return p.selected; }), function (p) { return p.id; }).join(',')
            };

            if ($scope.editableUser.password) {
                data.password = $scope.editableUser.password;
            }

            $scope.proccessing = true;

            if ($scope.editableUser.id) {
                $http.put(_env.apiUrl + '/users/' + $scope.editableUser.id, data).then(function(response) {
                    $('#modal-default').modal('hide');
                    getUsers();
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            } else {
                $http.post(_env.apiUrl + '/users', data).then(function(response) {
                    $('#modal-default').modal('hide');
                    getUsers();
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            }
        }

        $scope.deleteUser = function (user) {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    $scope.proccessing = true;
                    $http.delete(_env.apiUrl + '/users/' + user.id).then(function () {
                        getUsers();
                        Swal.fire({
                            type: 'success',
                            title: 'User Permissions successfully deleted',
                            position: 'top-end',
                            timer: 1000
                        });
                    }, function (reason) {
                        Swal.fire({
                            type: 'error',
                            title: 'Oops...',
                            text: JSON.stringify(reason.data, null, 2)
                        });
                    });
                }
            });
        }
    }
})();